import React from "react";
import "./ButtonTabGroup.css";

export function ButtonTabGroup({ tabOptions, activeTab, handleChange }) {
  return (
    <div className="btn-group btn-group-custom" role="group" aria-label="Time filter">
      {tabOptions.map((option) => (
        <button
          key={option.value}
          type="button"
          className={`btn btn-sm btn-tab${activeTab === option.value ? " active" : ""}`}
          onClick={() => handleChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
